"use strict";

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentCalendarView = void 0;

var react_1 = __importStar(require("react"));

var Calendar_1 = require("../Calendar");

function FragmentCalendarView(_ref) {
  var _this = this;

  var headerLeft = _ref.headerLeft,
      headerRight = _ref.headerRight,
      refetch = _ref.refetch,
      _loading = _ref.loading,
      monthSelected = _ref.monthSelected,
      renderCalendarDate = _ref.renderCalendarDate;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      stateLoading = _ref3[0],
      setLoading = _ref3[1];

  var loading = _loading || stateLoading;
  return react_1["default"].createElement(Calendar_1.Calendar, {
    headerLeft: headerLeft,
    headerRight: headerRight,
    loading: loading,
    onPanelChange: function onPanelChange(date) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var monthString;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(refetch || monthSelected)) {
                  _context.next = 17;
                  break;
                }

                monthString = date.clone().endOf('month').format();
                setLoading(true);
                _context.prev = 3;

                if (!refetch) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return refetch(btoa("0_*_".concat(JSON.stringify(monthString))));

              case 7:
                _context.next = 12;
                break;

              case 9:
                if (!monthSelected) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return monthSelected(monthString);

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);

              case 16:
                setLoading(false);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14]]);
      }));
    },
    dateCellRender: renderCalendarDate
  });
}

exports.FragmentCalendarView = FragmentCalendarView;